import { render, staticRenderFns } from "./addUserDialog.vue?vue&type=template&id=1331a87e&scoped=true&"
import script from "./addUserDialog.vue?vue&type=script&lang=js&"
export * from "./addUserDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1331a87e",
  null
  
)

export default component.exports